<div class="container" [class.mobile-container]="isMobile()" [class.embedded]="embedded()">
  @if (showVerificationBanner()) {
    <app-parent-ai-verification-banner />
  }

  @if (planGateCode(); as gateCode) {
    <app-parent-ai-plan-gate-banner
      [planGateCode]="gateCode"
      [planGateLimit]="planGateLimit()"
      (dismissed)="dismissPlanGate()"
    />
  }

  @if (showHeader()) {
    <app-parent-ai-assistant-card
      [isMobile]="isMobile()"
      [isVerificationMode]="isVerificationMode()"
      [selectedChild]="selectedChild()"
      [showTopicsPanel]="showTopicsPanel()"
      [showTopicsButton]="!isNeutralChildScope()"
      [filteredTopicsCount]="filteredTopics().length"
      (topicsPanelClick)="toggleTopicsPanel()"
    />
  }

  @if (showHeader() && !isVerificationMode() && !isNeutralChildScope()) {
    <app-parent-ai-topics-panel
      [open]="showTopicsPanel()"
      [isLoadingTopics]="isLoadingTopics()"
      [topicCounts]="topicCounts()"
      [filteredTopics]="filteredTopics()"
      [selectedTopicId]="selectedTopicId()"
      (close)="toggleTopicsPanel()"
      (topicSelected)="selectTopic($event)"
      (newConversation)="startNewConversation()"
    />
  }

  @if (!isVerificationMode() && !isNeutralChildScope() && selectedTopic(); as topic) {
    <app-parent-ai-active-topic-bar [topic]="topic" (clear)="startNewConversation()" />
  }

  <app-parent-ai-chat-body
    [isVerificationMode]="isVerificationMode()"
    [isLoadingConversation]="isLoadingConversation()"
    [displayMessages]="displayMessages()"
    [isSending]="isSending()"
    [pendingUserMessage]="pendingUserMessage()"
    [sendErrorMessage]="sendErrorMessage()"
    [userDisplayName]="userDisplayName()"
    [userAvatarUrl]="userChatAvatarUrl()"
    [userInitialsSource]="userChatInitialsSource()"
    [selectedChild]="selectedChild()"
  />

  <div class="chat-composer">
    <app-parent-ai-chat-footer
      [message]="messageInput()"
      (messageChange)="messageInput.set($event)"
      [showSpeechToText]="showSpeechToText()"
      [isTranscribing]="isTranscribing()"
      [isRecording]="isRecording()"
      (send)="sendMessage()"
      (toggleSpeechToText)="toggleSpeechToText()"
    />
    <app-parent-ai-disclaimer-banner />
  </div>

  @if (!isVerificationMode() && !isNeutralChildScope() && showTopicsPanel()) {
    <app-parent-ai-overlay (dismiss)="showTopicsPanel.set(false)" />
  }
</div>
